module.exports.GET_APPS = 'GET_APPS';
